<h2>{{record.description}}</h2>
<div class="fx-row fx-wrap fx-justify-start fx-items-start fx-sm-column fx-xs-column fx-md-column" style="gap: 24px">
  <div class="fx-fill fx-gt-md-flex-half-gap">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{'Descrizione' | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table>
          <tbody>
            <tr>
              <td>{{'Codice' | translate}}</td>
              <td><span>{{record.code}}</span></td>
            </tr>
            <tr>
              <td>{{'Stato' | translate}}</td>
              <td>
                <div style="display:flex;align-items: center;">
                  <span
                    [class.red-bg]='record.active_status === 0'
                    [class.green-bg]='record.active_status === 1 && record.publish_on_web > 0'
                    [class.orange-bg]='record.active_status === 1 && record.publish_on_web !== 1'
                  class="record-status-bar" style="width:6px;height:24px;display:inline-block;"></span>
                  @if (record.active_status === 0) {
                    <span>{{'Non Attivo' | translate}}</span>
                  }
                  @if (record.active_status === 1 && record.publish_on_web === 0) {
                    <span>{{'Attivo' | translate}}</span>
                  }
                  @if (record.active_status === 1 && record.publish_on_web === 1) {
                    <span>{{'Attivo e pubblicato' | translate}}</span>
                  }
                  @if (record.active_status === 1 && record.publish_on_web === 2) {
                    <span>{{'Attivo e pubblicato*' | translate}}</span>
                  }
                </div>
              </td>
            </tr>
            @if (record.destinations) {
              <tr>
                <td>{{'Destinazioni' | translate}}</td>
                <td><ul>@for (destination of record.destinations; track destination) {
                  <li>{{destination.description}}</li>
                }</ul></td>
              </tr>
            }
            @if (record.properties.price.value) {
              <tr>
                <td>{{'Prezzo' | translate}}</td>
                <td><span>{{record.properties.price.value | currency:'EUR'}}</span></td>
              </tr>
            }
            @if (record.properties.email.value) {
              <tr>
                <td>Email</td>
                <td><span>{{record.properties.email.value}}</span></td>
              </tr>
            }
            @if (record.properties.phone.value) {
              <tr>
                <td>{{'Telefono' | translate}}</td>
                <td><span>{{record.properties.phone.value}}</span></td>
              </tr>
            }
          </tbody>
        </table>

        @if (record.properties.note_booking.value) {
          <div>
            <span class='h2'>{{'Note' | translate}}</span>
            <div style='padding: 8px;border: 1px solid #eee;border-radius: 8px;'>
              {{record.properties.note_booking.value}}
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="fx-flex fx-fill">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{'Traduzioni Attive' | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table>
          <tbody>
            @for (languageCode of record.active_language_codes; track languageCode) {
              <tr>
                <td><img class='flag' [src]='"assets/images/flags/4x3/" + languageCode + ".svg"' /></td>
                <td>@if (appService.supportedLanguages[languageCode]) {
                  <span>{{appService.supportedLanguages[languageCode].description}}</span>
                }</td>
              </tr>
            }
          </tbody>
        </table>
        @if (!record.active_language_codes || record.active_language_codes.length === 0) {
          <p class='secondary-text'>{{'Nessuna traduzione attiva' | translate}}</p>
        }
      </mat-card-content>
    </mat-card>

  </div>

  <div class="fx-fill fx-lt-lg-flex-full fx-lg-flex-half-gap">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Media</mat-card-title>
      </mat-card-header>
      @if (record.master_image) {
        <img mat-card-image alt='Immagine di copertina' [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + record.master_image'/>
      }
      <mat-card-content>
        @if (!record.master_image) {
          <p class='secondary-text'>{{'Nessuna immagine di copertina' | translate}}</p>
        }

        <h3>{{'Immagini' | translate}}</h3>
        @if (record.carousel_images) {
          <div class="carousel-images fx-row fx-wrap" style="gap: 10px">
            @for (document of record.carousel_images; track trackImageBy($index, document)) {
              <img [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + document.id'>
            }
          </div>
        }

        @if (!record.carousel_images || record.carousel_images.length === 0) {
          <p class='secondary-text'>{{'Nessuna immagine inserita' | translate}}</p>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="fx-fill fx-lt-lg-flex-full fx-lg-flex-half-gap"></div>
</div>